import React, { memo } from 'react';
import styled from 'styled-components';
import { CommonContainerStyle } from '../styles';
import { translate } from '../../../../common/translation/translate';

interface TemperatureInfoProps {
    temperature: string; 
    feelsLike: string;
}

export const TemperatureInfo = memo(({ temperature, feelsLike }: TemperatureInfoProps) => {
    return (
        <Container>
            <Temp>
                {temperature}
            </Temp>
            <FeelsLike>
                {`${translate('feelsLike')} ${feelsLike}`}
            </FeelsLike>
        </Container>
    );
});

const Container = styled.div`
    ${CommonContainerStyle}
    width: calc(100% - 59px);
    line-height: 1;
    justify-content: center;
`;

const Temp = styled.div`
    font-size: 44px;
    font-weight: 400;
    color: #666;
`;

const FeelsLike = styled.div`
    font-size: 13px;
    font-weight: 400;
    color: #aaa;
`;